import styled from "styled-components";
import { Icon } from "@finvia/money-ui";

// TODO: #6465. Remove magic numbers and rely on the Stack component

export const TEMPDeleteIcon = styled(Icon)`
  margin-top: 36px;
  cursor: pointer;
`;
